import {
    Globe,
    AppWindow,
    Smartphone,
    Boxes,
    Palette,
    Megaphone,
    Share2,
    Image as ImageIcon,
    ServerCog,
    MailCheck,
    Compass,
} from "lucide-react";

export const ACCENTS = {
    blue: { icon: "text-blue-500", soft: "bg-blue-50", hoverBorder: "hover:border-blue-300", bar: "bg-blue-500", chip: "bg-blue-100 text-blue-700" },
    purple: { icon: "text-purple-500", soft: "bg-purple-50", hoverBorder: "hover:border-purple-300", bar: "bg-purple-500", chip: "bg-purple-100 text-purple-700" },
    teal: { icon: "text-teal-500", soft: "bg-teal-50", hoverBorder: "hover:border-teal-300", bar: "bg-teal-500", chip: "bg-teal-100 text-teal-700" },
    amber: { icon: "text-amber-500", soft: "bg-amber-50", hoverBorder: "hover:border-amber-300", bar: "bg-amber-500", chip: "bg-amber-100 text-amber-700" },
    coral: { icon: "text-rose-500", soft: "bg-rose-50", hoverBorder: "hover:border-rose-300", bar: "bg-rose-500", chip: "bg-rose-100 text-rose-700" },
    green: { icon: "text-emerald-500", soft: "bg-emerald-50", hoverBorder: "hover:border-emerald-300", bar: "bg-emerald-500", chip: "bg-emerald-100 text-emerald-700" },
};

export const SERVICES = [
    { title: "Website Design & Development", slug: "website-design", description: "Fast, beautiful, SEO-ready websites that turn visitors into customers.", icon: Globe, accent: "blue" },
    { title: "Web Applications", slug: "web-applications", description: "Dashboards, portals, and SaaS products built to scale with your business.", icon: AppWindow, accent: "purple" },
    { title: "Mobile Apps (iOS/Android)", slug: "mobile-apps", description: "Native-quality apps your customers carry in their pocket every day.", icon: Smartphone, accent: "teal" },
    { title: "Custom Software / Business Apps", slug: "custom-software", description: "Internal tools that replace spreadsheets, paperwork, and busywork.", icon: Boxes, accent: "amber" },
    { title: "Logo & Brand Identity Design", slug: "brand-identity", description: "Logos and brand systems people remember at a glance.", icon: Palette, accent: "coral" },
    { title: "Digital Marketing & Ad Campaigns", slug: "digital-marketing", description: "Google & Meta ad campaigns tuned for ROI, not vanity metrics.", icon: Megaphone, accent: "green" },
    { title: "Social Media Content Management", slug: "social-media", description: "Consistent, on-brand content that keeps you top of mind.", icon: Share2, accent: "blue" },
    { title: "Event Posters & Promotional Design", slug: "event-posters", description: "Print and digital designs that fill seats and move product.", icon: ImageIcon, accent: "purple" },
    { title: "Business Tech Setup", slug: "business-tech-setup", description: "Domains, hosting, and tools — set up right the first time.", icon: ServerCog, accent: "teal" },
    { title: "Email & Microsoft 365 Admin Setup", slug: "email-m365-setup", description: "Professional email and Microsoft 365, configured and managed.", icon: MailCheck, accent: "amber" },
    { title: "Business Ideas & Digital Strategy Consulting", slug: "strategy-consulting", description: "From napkin sketch to launch plan — honest, practical advice.", icon: Compass, accent: "green" },
];

export const BUDGETS = [
    "Under $1,000",
    "$1,000 – $5,000",
    "$5,000 – $10,000",
    "$10,000+",
    "Not sure yet",
];

export const PHONE_DISPLAY = "403-690-0222";
export const PHONE_TEL = "tel:+14036900222";
export const EMAIL = "itsjaspreet4u@gmail.com";
